import React from 'react';
import { Stack, Title, Text, List, Divider } from '@mantine/core';
import { useTranslation } from 'react-i18next';

const TermsOfService = () => {
  const { t } = useTranslation();

  return (
    <Stack p="xl" maw={800} mx="auto">
      <Title order={2} fw={800}>{t('legal.tos.title')}</Title>
      {Object.entries(t('legal.tos.sections', { returnObjects: true })).map(
        ([key, section], index, array) => (
          <React.Fragment key={key}>
            <Stack spacing="md">
              <Title order={3}>{section.title}</Title>
              {section.content && <Text>{section.content}</Text>}
              {section.list && (
                <List>
                  {section.list.map((item, index) => (
                    <List.Item key={index}>{item}</List.Item>
                  ))}
                </List>
              )}
              {section.subsections &&
                section.subsections.map((subsection, index) => (
                  <Stack key={index} spacing="md" ml="md">
                    <Title order={4}>{subsection.title}</Title>
                    {subsection.content && <Text>{subsection.content}</Text>}
                    {subsection.list && (
                      <List>
                        {subsection.list.map((item, idx) => (
                          <List.Item key={idx}>{item}</List.Item>
                        ))}
                      </List>
                    )}
                  </Stack>
                ))}
            </Stack>
            {index < array.length - 1 && <Divider my="xl" />}
          </React.Fragment>
        )
      )}
    </Stack>
  );
};

export default TermsOfService; 